<template>
  <div class="search-results">
    <ais-hits>
      <template #default="{ items }">
        <template v-if="items.length > 0">
          <div
            v-for="item in items"
            :key="item.id"
            class="hit"
          >
            <a
              :href="'member-resources/' + item.slug"
              class="card"
            >
              <div class="media-type">
                <i
                  class="icon-sm icon-reg"
                  :class="'icon-' + item.media_type"
                  aria-hidden="true"
                />
                <span
                  class="text-title-sm"
                  :class="viewType === 'grid' ? 'not-sr-only' : 'sr-only'"
                >
                  {{ item.media_type }}
                </span>
              </div>
              <h3 class="text-title">{{ item.title }}</h3>
              <div
                v-if="viewType === 'grid'"
                class="btn-text"
              >Learn more <i
                class="icon-sm icon-reg icon-arrow"
                aria-hidden="true"
              /></div>
            </a>
          </div>
        </template>
        <template v-else>
          <p class="text-warning">
            No resource posts available
          </p>
        </template>
      </template>
    </ais-hits>
    <ais-pagination :padding="2" />
  </div>
</template>

<script>
/* Components */
import { AisHits, AisPagination } from 'vue-instantsearch/vue3/es';

export default {
  components: {
    AisHits,
    AisPagination,
  },
  props: {
    viewType: {
      type: String,
      required: true,
    }
  },
};
</script>
